import React from "react";
import { Clock } from "lucide-react";

export const daysLeft = (end) => {
  const today = new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Paris" });
  return Math.round((Date.parse(end) - Date.parse(today)) / 86400000);
};

export const countdownLabel = (days, short = false) => {
  if (days === 0) return short ? "Dernier jour !" : "Dernier jour pour profiter de l'offre !";
  const base = days === 1 ? "Plus qu'1 jour" : `Plus que ${days} jours`;
  return short ? base : `${base} pour profiter de l'offre`;
};

export const OfferCountdown = ({
  offer,
  short = false,
  testId = "flexfuel-offer-countdown",
  className = "mb-4 px-4 py-2 text-sm rounded-2xl sm:rounded-full",
}) => {
  if (!offer.active || !offer.end_date) return null;
  const days = daysLeft(offer.end_date);
  if (days < 0) return null;
  return (
    <div
      data-testid={testId}
      className={`inline-flex items-center gap-2 bg-[#FF3B30] text-white font-bold uppercase tracking-wide shadow-[0_0_24px_rgba(255,59,48,0.35)] ${className}`}
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-75 animate-ping" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-white" />
      </span>
      <Clock size={short ? 12 : 16} />
      <span data-testid={`${testId}-label`}>{countdownLabel(days, short)}</span>
    </div>
  );
};
